export const multiTerritoryMember = {
  id: 'MemberID 204187',
  name: 'Alex Rivera',
  role: 'Member (parent / account holder)',
  /** Dates are illustrative "first associated with this franchise" dates (field pending validation). */
  attributions: [
    { territory: 'Charlotte North', date: 'Jun 3, 2026', source: 'Local event' },
    { territory: 'Raleigh–Cary', date: 'Jun 18, 2026', source: 'Digital · paid ad' },
  ],
};

/** Example for the date range 6/1 – 7/30. */
export const conversionWindowExamples = [
  { member: 'Member A', added: 'Jun 4', registrations: '2 (two kids), Jun 20', outcome: 'Converted', detail: 'Added and registered inside the range.' },
  { member: 'Member B', added: 'Jul 25', registrations: '1, Aug 3', outcome: 'Not converted', detail: 'Registered after the range ends.' },
  { member: 'Member C', added: 'Aug 2025', registrations: '1, Jul 10', outcome: 'Not in range', detail: 'Added before the range; excluded.' },
  { member: 'Member D', added: 'Jun 12', registrations: 'None', outcome: 'Not converted', detail: 'Member only.' },
];

export const dedupParticipant = {
  name: 'Maya R. · PlayerID 55821',
  age: 8,
  member: 'MemberID 204187 (parent account)',
  registrations: [
    { program: 'Soccer League', season: 'Summer 2026', purchased: 'May 12, 2026' },
    { program: 'Basketball Camp', season: 'Summer 2026', purchased: 'Jun 2, 2026' },
    { program: 'Flag Football Instructional', season: 'Summer 2026', purchased: 'Jun 20, 2026' },
    { program: 'Flag Football League', season: 'Fall 2026', purchased: 'Jul 28, 2026' },
  ],
};
